var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.575 0C16.5662 0.00857375 16.5485 0.00857375 16.5219 0.00857375C7.57416 0.00857375 0.297455 7.06477 0.297455 15.7414C0.297455 19.2824 1.54413 22.7204 3.82529 25.4897L1.46456 30.8055C1.27004 31.2427 1.48224 31.7486 1.92432 31.9286C2.08348 31.9972 2.26031 32.0144 2.4283 31.9887L11.0843 30.514C12.8173 31.1227 14.6387 31.4314 16.4777 31.4228C25.4255 31.4228 32.7022 24.3666 32.7022 15.69C32.7199 7.03905 25.4963 0.00857375 16.575 0ZM16.4866 29.7166C14.7801 29.7166 13.0914 29.4165 11.491 28.8335C11.3407 28.7735 11.1816 28.7649 11.0224 28.7906L3.73687 30.0253L5.66436 25.6784C5.79698 25.3783 5.74393 25.0268 5.52289 24.7781C4.47957 23.6035 3.64845 22.266 3.0649 20.8171C2.41062 19.1966 2.07463 17.4733 2.07463 15.7328C2.07463 7.99931 8.56443 1.71475 16.5308 1.71475C24.4795 1.6976 30.9339 7.93072 30.9427 15.6385C30.9427 15.6557 30.9427 15.6728 30.9427 15.69C30.9427 23.4321 24.4529 29.7166 16.4866 29.7166Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.797 12.5781H11.0225C10.5362 12.5781 10.1383 12.9639 10.1383 13.4355C10.1383 13.9071 10.5362 14.2929 11.0225 14.2929H15.797C16.2833 14.2929 16.6812 13.9071 16.6812 13.4355C16.6812 12.9639 16.2833 12.5781 15.797 12.5781Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9862 16.8652H11.0225C10.5362 16.8652 10.1383 17.2511 10.1383 17.7226C10.1383 18.1942 10.5362 18.58 11.0225 18.58H21.9862C22.4725 18.58 22.8704 18.1942 22.8704 17.7226C22.8704 17.2511 22.4725 16.8652 21.9862 16.8652Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChat);
export default __webpack_public_path__ + "static/media/chat.c59f2d5303eca900263cf3aabd38215c.svg";
export { ForwardRef as ReactComponent };